export const cnpjMask = '##.###.###/####-##';
